import Vue from 'vue'
// import App from './App.vue'
import store from '@/store/index'

import vueCustomElement from 'vue-custom-element'

/* import degli oggetti ui */
import Menu from '@/components/Menu/Menu.vue'
import ReportLoader from '@/components/Container/ReportLoader.vue'
import StatsLinkLoader from '@/components/StatsLinkLoader/StatsLinkLoader.vue'
import UniqueId from 'vue-unique-id';

Vue.config.productionTip = false
Vue.use(UniqueId);


Vue.use(vueCustomElement);
// TODO: verificare perchè non importa 'document-register-element/build/document-register-element'
// import 'document-register-element/build/document-register-element';

/* Inizializzo i Custom Element */
Menu.store = store
Vue.customElement('modanet-menu-vue', Menu);

/* Inizializzo i Custom Element */
ReportLoader.store = store
Vue.customElement('modanet-report-loader-vue', ReportLoader);

/* Inizializzo i Custom Element */
StatsLinkLoader.store = store
Vue.customElement('modanet-stats-link-loader-vue', StatsLinkLoader);

/* new Vue({
    store,
    render: h => h(App),
}).$mount('#app') */